import {
  getDirPrivate,
  getFilePrivate,
  setDirPrivate,
  setFilePrivate,
} from '@bangle.io/supabase';

/** Toggle whether a cloud note is private. Returns the new private state. */
export async function toggleNotePrivate(
  workspaceId: string,
  notePath: string,
): Promise<boolean> {
  const next = !(await getFilePrivate(workspaceId, notePath));
  await setFilePrivate(workspaceId, notePath, next);
  return next;
}

/** Toggle whether a cloud folder (and everything under it) is private. */
export async function toggleFolderPrivate(
  workspaceId: string,
  dirPath: string,
): Promise<boolean> {
  const next = !(await getDirPrivate(workspaceId, dirPath));
  await setDirPrivate(workspaceId, dirPath, next);
  return next;
}
